import React from 'react';
import { MapPinIcon, PhoneIcon, MessageCircleIcon, MailIcon } from 'lucide-react';
import { contact } from '../data/site';
import { Reveal } from './Reveal';
import { GlassCall, GlassWhatsApp } from './ContactButtons';
export function ContactFooter() {
  return <footer id="contacto" className="relative w-full bg-ink" data-id="element-25" data-mp="2ai3awjfew75q">
      <div className="absolute inset-x-0 top-0 h-20 bg-gradient-to-b from-plum-deep/50 to-transparent" data-id="element-26" data-mp="2ffmqbmnuipz9" />

      <div className="relative mx-auto max-w-7xl px-5 py-16 sm:py-20" data-id="element-27" data-mp="334xu7d0ht0hm">
        <div className="grid gap-14 lg:grid-cols-[1fr_1fr] lg:gap-20" data-id="element-28" data-mp="383sbubmq4j05">
          <div data-id="element-29" data-mp="2temg4xn3hax0">
            <Reveal data-id="element-30" data-mp="2tf4j0d49indw">
              <h2 className="font-serif text-4xl text-white sm:text-5xl" data-id="element-31" data-mp="2tdkygabkpq6b">Contacto</h2>
            </Reveal>
            <Reveal delay={0.1} data-id="element-32" data-mp="2ycedw8af7r94">
              <ul className="mt-9 space-y-6" data-id="element-33" data-mp="2ybcsb9vs3md5">
                <li className="flex items-start gap-4" data-id="element-34" data-mp="3m30exfm0cb9m">
                  <MapPinIcon className="mt-1 h-5 w-5 shrink-0 text-gold-light" aria-hidden="true" data-id="element-35" data-mp="3m1gtzbpepc1i" />
                  <span className="font-sans text-base leading-relaxed text-white/75" data-id="element-36" data-mp="3qvte7nypireb">{contact.location}</span>
                </li>
                <li className="flex items-start gap-4" data-id="element-37" data-mp="2gbsiy6055jz4">
                  <PhoneIcon className="mt-1 h-5 w-5 shrink-0 text-call" aria-hidden="true" data-id="element-38" data-mp="2g8woirni5dff" />
                  <a href={contact.footerPhoneHref} className="font-sans text-base text-white/75 transition-colors duration-200 ease-smooth hover:text-white" data-id="element-39" data-mp="2u4ik5ho8qvgt">
                    {contact.footerPhone}
                  </a>
                </li>
                <li className="flex items-start gap-4" data-id="element-40" data-mp="2z3lcc1j4h77d">
                  <MessageCircleIcon className="mt-1 h-5 w-5 shrink-0 text-wa" aria-hidden="true" data-id="element-41" data-mp="3d08nb87wtxwa" />
                  <a href={contact.whatsappHref} target="_blank" rel="noopener noreferrer" className="font-sans text-base text-white/75 transition-colors duration-200 ease-smooth hover:text-white" data-id="element-42" data-mp="390q2ecg39mtg">
                    {contact.whatsappNumber}
                  </a>
                </li>
                <li className="flex items-start gap-4" data-id="element-43" data-mp="3iop0t8xsl0c3">
                  <MailIcon className="mt-1 h-5 w-5 shrink-0 text-gold-light" aria-hidden="true" data-id="element-44" data-mp="3irl1h510y348" />
                  <a href={`mailto:${contact.email}`} className="break-all font-sans text-base text-white/75 transition-colors duration-200 ease-smooth hover:text-white" data-id="element-45" data-mp="3nqo2medvvp6x">
                    {contact.email}
                  </a>
                </li>
              </ul>
            </Reveal>
            <Reveal delay={0.2} data-id="element-46" data-mp="a9f3ee4ukjan">
              <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:flex-wrap sm:justify-start" data-id="element-47" data-mp="aagqjgz50w8q">
                <GlassCall size="md" phone="footer" data-id="element-48" data-mp="faum3zjjydpv">
                  Llamar {contact.footerPhone}
                </GlassCall>
                <GlassWhatsApp size="md" data-id="element-49" data-mp="o96muue4urw1">WhatsApp</GlassWhatsApp>
              </div>
            </Reveal>
          </div>

          <div className="space-y-10" data-id="element-50" data-mp="28rqvm9grgn2w">
            <Reveal delay={0.1} data-id="element-51" data-mp="28stouo1k31lz">
              <div id="terminos" className="rounded-2xl border border-white/10 bg-white/[0.03] p-7" data-id="element-52" data-mp="24q5e2ata7kmd">
                <h3 className="font-serif text-2xl text-gold-light" data-id="element-53" data-mp="1zqkcrtqn306h">Términos y Condiciones</h3>
                <p className="mt-3 font-sans text-sm leading-relaxed text-white/60" data-id="element-54" data-mp="1urzc5t7h6ehi">
                  Los servicios se ofrecen bajo consentimiento del consultante y con fines de
                  acompañamiento espiritual. Los tiempos y resultados varían según cada caso y no se
                  garantizan plazos específicos. No atendemos a menores de 18 años.
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.18} data-id="element-55" data-mp="2drd98k0i45c8">
              <div id="politicas" className="rounded-2xl border border-white/10 bg-white/[0.03] p-7" data-id="element-56" data-mp="2dqbmhia4hueo">
                <h3 className="font-serif text-2xl text-gold-light" data-id="element-57" data-mp="3b7af31rxz7ut">Políticas</h3>
                <p className="mt-3 font-sans text-sm leading-relaxed text-white/60" data-id="element-58" data-mp="36ehbih87m5kb">
                  Toda consulta es estrictamente confidencial. Tus datos personales se usan
                  únicamente para dar seguimiento a tu caso y nunca se comparten con terceros. Puedes
                  solicitar la eliminación de tu información escribiendo a nuestro correo.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-59" data-mp="39n7gw7kjuybs">
        <div className="mx-auto flex max-w-7xl flex-col items-center gap-5 px-5 py-9 text-center lg:flex-row lg:justify-between lg:text-left" data-id="element-60" data-mp="39oiq4mwrkyaa">
          <p className="font-serif text-base text-white/70" data-id="element-61" data-mp="2zyfsg9ep6w5m">
            Conjuros y Amarres <span className="text-gold-light" data-id="element-62" data-mp="34x0ri5i7r9sh">Para El Amor</span>
          </p>
          <nav aria-label="Legal" data-id="element-63" data-mp="34uxq6pbm1u8g">
            <ul className="flex flex-wrap items-center justify-center gap-6 font-sans text-sm text-white/55" data-id="element-64" data-mp="3sm37za142wle">
              <li data-id="element-65" data-mp="1875yqdfy6ba">
                <a href="#terminos" className="transition-colors duration-200 ease-smooth hover:text-gold-light" data-id="element-66" data-mp="18pbkdlztwvv">
                  Términos y Condiciones
                </a>
              </li>
              <li data-id="element-67" data-mp="1gy6nnbojs2ib">
                <a href="#politicas" className="transition-colors duration-200 ease-smooth hover:text-gold-light" data-id="element-68" data-mp="1gyzojw0trxsj">
                  Políticas
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <p className="mx-auto max-w-4xl px-5 pb-10 text-center font-sans text-xs leading-relaxed text-white/35" data-id="element-69" data-mp="1qrf8uzzlgygl">
          Aviso legal: los servicios espirituales aquí ofrecidos son de carácter esotérico y de
          entretenimiento personal. No sustituyen atención médica, psicológica ni legal. Los
          resultados pueden variar de una persona a otra y no constituyen una garantía. Servicio
          exclusivo para personas mayores de 18 años. © {new Date().getFullYear()} Conjuros y Amarres
          Para El Amor. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}